import { render, staticRenderFns } from "./accountManag.vue?vue&type=template&id=95832f88&scoped=true&"
import script from "./accountManag.vue?vue&type=script&lang=js&"
export * from "./accountManag.vue?vue&type=script&lang=js&"
import style0 from "./accountManag.vue?vue&type=style&index=0&id=95832f88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95832f88",
  null
  
)

export default component.exports